<template>
  <div id="toolbar" class="no-print">
    <div id="icons">
      <round-button-with-icon
        icon="left-arrow-single"
        v-if="checkForIcon('left-arrow')"
        @click="leftArrowClicked"
      />
      <round-button-with-icon
        v-if="checkForIcon('print')"
        icon="print"
        @click="print"
      />
      <round-button-with-icon
        v-if="checkForIcon('save')"
        :icon="saveProcessing ? 'spinner' : 'save'"
        @click="saveButtonClicked"
      />
      <round-button-with-icon
        v-if="checkForIcon('plus-sign')"
        icon="plus"
        @click="toggleAddMenuOpened"
      />
      <round-button-with-icon
        v-if="checkForIcon('checked-signature')"
        :icon="normalESignatureProcessing ? 'spinner' : 'checked-signature'"
        @click="markAsSigned"
      />
      <div v-if="checkForIcon('admin-signature')" class="e-sign-grouping">
        <round-button-with-icon
          icon="signature-admin"
          @click="toggleAdminESign"
        />
        <transition name="slide">
          <div class="e-sign-field" v-if="adminESignOpen">
            <Input
              title="Legal Name"
              :placeholder="`${user.given_name} ${user.family_name}`"
              :inputValue="eSignField"
              :error="eSignFieldNotFilled"
              @scs-input="setESignField"
            />
            <round-button-with-icon
              :icon="adminESignatureProcessing ? 'spinner' : 'circle-checkmark'"
              @click="submitAdminESign"
            />
          </div>
        </transition>
      </div>
      <div class="e-sign-grouping" v-if="checkForIcon('signature')">
        <round-button-with-icon icon="signature" @click="toggleESign" />
        <transition name="slide">
          <div class="e-sign-field" v-if="eSignOpen">
            <Input
              title="Legal Name"
              :placeholder="`${user.given_name} ${user.family_name}`"
              :inputValue="eSignField"
              @scs-input="setESignField"
            />
            <round-button-with-icon
              :icon="
                normalESignatureProcessing ? 'spinner' : 'circle-checkmark'
              "
              @click="submitESign"
            />
          </div>
        </transition>
      </div>
      <round-button-with-icon
        v-if="checkForIcon('right-arrow')"
        icon="right-arrow-single"
        @click="rightArrowClicked"
      />
      <round-button-with-icon icon="x" @click="close" />
    </div>
    <Transition name="grow">
      <div id="e-sign-disclaimer" v-if="eSignOpen">
        <p>
          By electronically signing the agreement, I agree and consent to do
          business electronically. I understand that this agreement is legally
          binding.
        </p>
      </div>
    </Transition>
    <Transition name="grow">
      <div id="add-button-list" v-if="addMenuOpened">
        <item-tile
          v-for="item in addOnItems"
          :key="item.id"
          :text="item[addOnItemTitle]"
          @primary-icon-clicked="toggleAddOnItemFromIncluded(item)"
          :selected="checkIfIncludes(item)"
          @click="toggleAddOnItemFromIncluded(item)"
        />
      </div>
    </Transition>
  </div>
</template>
<script>
import Input from "../Elements/Input.vue";
import RoundButtonWithIcon from "../UI/RoundButtonWithIcon.vue";
import ItemTile from "../UI/ItemTile.vue";
export default {
  data() {
    return {
      adminESignOpen: false,
      eSignFieldNotFilled: false,
      eSignOpen: false,
      addMenuOpened: false,
      eSignField: undefined,
    };
  },
  methods: {
    print() {
      window.print();
    },
    setESignField(val) {
      this.eSignField = val;
    },
    toggleESign() {
      this.eSignOpen = !this.eSignOpen;
    },
    checkForIcon(icon) {
      return this.icons.includes(icon);
    },
    checkIfIncludes(item) {
      if (
        this.includedItems.find((x) => {
          return x.id
            ? x.id == item.id
            : x.name
            ? x.name == item.name
            : x.Name
            ? x.Name == item.Name
            : x == item;
        })
      ) {
        return true;
      } else {
        return false;
      }
    },
    toggleAddMenuOpened() {
      this.addMenuOpened = !this.addMenuOpened;
    },
    toggleAddOnItemFromIncluded(item) {
      this.$emit("toggleAddOnItemFromIncluded", item);
    },
    submitESign() {
      if (!this.eSignField) {
        this.eSignFieldNotFilled = true;
      } else {
        let signature = {
          signerName: this.eSignField,
          signerDate: new Date(),
          signerUUID: this.$store.state.user.userId,
          status: "signed",
        };
        this.$emit("submitESignature", signature);
      }
    },
    markAsSigned() {
      let signature = {
        signerName: "Marked By Admin",
        signerDate: new Date(),
        signerUUID: this.$store.state.user.userId,
        status: "signed",
      };
      this.$emit("submitESignature", signature);
    },
    submitAdminESign() {
      if (!this.eSignField) {
        this.eSignFieldNotFilled = true;
      } else {
        let signature = {
          signerName: this.eSignField,
          signerDate: new Date(),
          signerUUID: this.$store.state.user.userId,
          status: "signed",
        };
        this.$emit("submitAdminESignature", signature);
      }
    },
    toggleAdminESign() {
      this.adminESignOpen = !this.adminESignOpen;
    },
    close() {
      this.$emit("close");
    },
    leftArrowClicked() {
      this.$emit("leftArrowClicked");
    },
    saveButtonClicked() {
      this.$emit("saveButtonClicked");
    },
    rightArrowClicked() {
      this.$emit("rightArrowClicked");
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  created() {},
  components: {
    Input,
    RoundButtonWithIcon,
    ItemTile,
  },
  emits: [
    "submitESignature",
    "submitAdminESignature",
    "toggleAddOnItemFromIncluded",
    "normalESignatureProcessing",
    "adminESignatureProcessing",

    "leftArrowClicked",
    "saveButtonClicked",
    "rightArrowClicked",
    "close",
  ],
  props: [
    "icons",
    "addOnItems",
    "saveProcessing",
    "includedItems",
    "addOnItemTitle",
  ],
};
</script>
<style scoped>
#toolbar {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.e-sign-grouping,
.e-sign-field {
  display: flex;
  align-items: center;
  width: auto;
}
#icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  width: 100%;
}
#e-sign-disclaimer {
  width: 100%;
  height: auto;
  justify-content: space-between;
}

#add-button-list {
  width: 100%;
  display: flex;
  overflow: scroll;
  padding: 20px;
}

.bubble-pool {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.grow-enter-active,
.grow-leave-active {
  transition: all 1s ease;
}

.grow-enter-from,
.grow-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 1s ease;
}

.slide-enter-from,
.slide-leave-to {
  width: 0px;
  opacity: 0;
  transform: translateX(100%);
  overflow: hidden;
}

@media print {
  #toolbar {
    display: none;
  }

  .no-print {
    display: none;
  }
}
</style>
